module.exports = __webpack_public_path__ + "static/media/icon_search.a5fd43f3.png";